import { useState, useEffect, useRef } from "react";
import { Wheel } from "react-custom-roulette";
import Confetti from "react-confetti";
import clienteAxios from "../../axios";
import Cargador from "../../componentes/Cargador";

const Ruleta = ({ }) => {
    const initialPrizes = [
        { label: "$100 MXN", color: "#10b981", textColor: "#0b2319", prob: 20 }        
    ];

    const [mustSpin, setMustSpin] = useState(false);
    const [prizeNumber, setPrizeNumber] = useState(0);
    const [wheelSpun, setWheelSpun] = useState(false); // Nuevo estado para controlar si ya se ha girado la rueda
    const [showConfetti, setShowConfetti] = useState(false);
    const [premio, setPremio] = useState(null);
    const [imagen, setImagen] = useState(null);
    const [ListaPremios, setListaPremios] = useState(initialPrizes);
    const [premioSeleccionado, setPremioSeleccionado] = useState([]);
    const [indexPremio, setIndexPremio] = useState(0)
    const [correo, setCorreo] = useState("");
    const [cargador, setCargador] = useState(false);
    const [result, setResult] = useState(null);

    useEffect(() => {
        consultarPremios();
    }, []);

    const consultarPremios = async () => {
        const config = {
            "Content-Type": "application/json",
        };
        const data = {
            sp: "premios",
            op: "listar",
        };
        try {
            setCargador(true);             
            const result = await clienteAxios.post("/api/sp", data, config);
            let premios = [];           
            if (result) {
                result.data.data[0].forEach((element) => {                    
                    const { descripcion, color, valor, idPremio, url } = element;
                    let dato = {
                        option: descripcion,
                        style: { backgroundColor: color, textColor: "#FFFFFF" },
                        prob: valor,
                        url: url,
                    };
                    premios.push(dato);
                });                
                setPremioSeleccionado(result.data.data[1][0])                      
                setListaPremios(premios);                  
            }
        } catch (error) {
            console.error("Error al consultar premios:", error);
        } finally {
            setCargador(false);
        }
    };



    const girar = () => {         
        setMustSpin(true);
        setWheelSpun(true);                  
        setPrizeNumber(premioSeleccionado.indexs);   
        setPremio(premioSeleccionado.descripcion);
        setImagen(premioSeleccionado.url);            
    };

    const cerrarRuleta = () => {
        window.location.href = '/';
    };

    const handleStop = () => {         
        setMustSpin(false);
        setShowConfetti(true);               
        enviarPremioCorreo();
    };

    const enviarPremioCorreo = () => {
        const data = {
            "sp": "respuestas",
            "op": "actualizar",       
            "correo": correo ? correo :"alberto@cruzespinosa.com",            
            "premio": premio,            
            "idPremio":premioSeleccionado.idPremio
        };
        

        clienteAxios
            .post("/api/sp", data)
            .then((response) => {
                console.log("Correo enviado:", response.data);
            })
            .catch((error) => {
                console.error("Error al enviar correo:", error);
            });
    };

    return (
        <>
            <div className="fixed inset-0 flex items-center justify-center bg-black/80 bg-opacity-50 ">
                {showConfetti && (
                    <Confetti
                        width={window.innerWidth}
                        height={window.innerHeight}
                        recycle={true}
                        numberOfPieces={300}
                    />
                )}

                <div className="bg-white p-6 shadow-lg text-center rounded-3xl sm:w-full md:w-1/4">
                    <div>
                        {!ListaPremios ? <Cargador />
                            :
                            <>
                                <h2 className="text-2xl font-semibold mb-4">
                                    ¡Ruleta de Prueba!
                                </h2>
                                {!showConfetti &&
                                    <Wheel
                                        mustStartSpinning={mustSpin}
                                        prizeNumber={prizeNumber}
                                        data={ListaPremios ? ListaPremios : []}
                                        backgroundColors={["#3e3e3e", "#3e3e3e"]}
                                        textColors={["#ffffff"]}
                                        onStopSpinning={() => {
                                            handleStop();
                                        }}
                                    />
                                }
                            </>
                        }
                        {!wheelSpun && (
                            <>
                                <div className=" w-full">
                                    <input
                                        type="email"
                                        placeholder="Escribe tu correo"
                                        className="w-full rounded-lg"
                                        required
                                        onChange={(e) => setCorreo(e.target.value)}
                                    />
                                </div>
                                <button
                                    onClick={girar}
                                    className="bg-orange-500 text-white rounded px-4 py-2 mt-4"
                                >
                                    ¡Gira y mucha suerte!
                                </button>
                            </>
                        )}
                        {wheelSpun && !mustSpin && (
                            <>
                                <p className="p-4 text-2xl font-semibold">
                                    Recibe tu premio al correo{" "}
                                    <span className="text-blue-600"> {correo} </span> ,para ser
                                    válido para el premio {premio}
                                </p>
                                <p className="text-center font-bold ">
                                    ¡Aprovecha tu cupón! Canjea tu beneficio de martes a viernes
                                    con vigencia de 1 mes.
                                </p>
                                <div className="w-1/2 m-auto">
                                    <img src={imagen} className="max-h-44" alt="Premio" />
                                </div>
                                <button className="bg-blue-500 text-white rounded px-4 py-2 mt-4 " onClick={cerrarRuleta}>
                                    Cerrar
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Ruleta;
